import { Block } from '@/core/Block.js'

export class SubMenu extends Block {
  init() {
    super.init()
    this.toggle = this.el.querySelector('.c-nav-bar-menu-a')
    this.submenu = this.el.querySelector('.c-nav-bar-menu--sub')

    // bind methods
    this.showSubmenu = this.showSubmenu.bind(this)
    this.hideSubmenuIfNeeded = this.hideSubmenuIfNeeded.bind(this)
    this.toggleSubmenuActivation = this.toggleSubmenuActivation.bind(this)
    this.handleOutsideClick = this.handleOutsideClick.bind(this)
    this.onScroll = this.onScroll.bind(this)
  }

  addEvents() {
    super.addEvents()

    this.el.addEventListener('mouseover', this.showSubmenu)
    this.el.addEventListener('mouseout', this.hideSubmenuIfNeeded)
    this.el.addEventListener('click', this.toggleSubmenuActivation)

    document.addEventListener('click', this.handleOutsideClick)
    document.addEventListener('scroll', this.onScroll)
  }

  onScroll() {
    // this.hideSubmenuIfNeeded()
  }

  showSubmenu() {
    this.el.classList.add('is-active')
  }

  hideSubmenuIfNeeded() {
    if (!this.isActiveByClick) {
      this.el.classList.remove('is-active')
    }
  }

  toggleSubmenuActivation(e) {
    // this.isActiveByClick = !this.isActiveByClick

    // if (this.isActiveByClick) {
    //   this.showSubmenu()
    // } else {
    //   this.el.classList.remove('is-active')
    // }

    // e.stopPropagation() // to prevent global click listener from immediately hiding the submenu
  }

  handleOutsideClick(e) {
    if (!this.el.contains(e.target)) {
      this.isActiveByClick = false
      this.el.classList.remove('is-active')
    }
  }
}
